<script setup lang="ts">
import type { AddressHint } from '@/utils/yandexSearch'

/**
 * Выпадающий список подсказок под поиском: белая плашка r20 с тенью,
 * строки 51px — 14 SemiBold и 12 Medium серым.
 */
interface Props {
  items: AddressHint[]
}

defineProps<Props>()

const emit = defineEmits<{
  select: [item: AddressHint]
}>()
</script>

<template>
  <ul class="address-suggestions">
    <li v-for="item in items" :key="item.id">
      <button type="button" class="address-suggestions__row" @click="emit('select', item)">
        <span class="address-suggestions__title font-14-s">{{ item.title }}</span>
        <span class="address-suggestions__subtitle font-12-m">{{ item.subtitle }}</span>
      </button>
    </li>
  </ul>
</template>

<style scoped lang="scss">
.address-suggestions {
  overflow: hidden auto;
  max-height: 326px;
  padding: 10px 0;
  border-radius: var(--radius-xl);
  background: var(--surface-card);
  box-shadow: var(--shadow-soft);

  &__row {
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 6px 14px;
    border: 0;
    background: none;
    text-align: left;
    cursor: pointer;

    &:hover,
    &:active {
      background: var(--surface-hint);
    }
  }

  &__title {
    line-height: 21px;
    color: var(--text-color);
  }

  &__subtitle {
    line-height: 18px;
    color: var(--text-color-hint);
  }
}
</style>
